import { useContext } from 'react';
import { AppContext } from './AppContext';

// Custom hook for accessing the application's preloaded data.
// This data is expected to be loaded before the app renders.
export function useAppData() {
  const ctx = useContext(AppContext);

  if (!ctx) {
    throw new Error('useAppData hook must be called inside <AppProvider>');
  }

  return ctx;
}
